// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 129 ? "7bf36345" : chunkId) + "." + {"81":"25f643d42a5da6c6","113":"1a23fbe2d383da64","129":"41f9882ff5f53874","224":"57f8ec1ce56e3847","287":"3001e6a718437c41","305":"37e05c35f68c010c","634":"f0c3c6f4d5c55caa","870":"7f96ef6bf8227e0c"}[chunkId] + ".js";
};